import { render, staticRenderFns } from "./subscription_plans.vue?vue&type=template&id=6baca381&scoped=true"
import script from "./subscription_plans.vue?vue&type=script&lang=js"
export * from "./subscription_plans.vue?vue&type=script&lang=js"
import style0 from "./subscription_plans.vue?vue&type=style&index=0&id=6baca381&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baca381",
  null
  
)

export default component.exports